import React, { memo, useMemo } from "react";
import { HStack, Text } from "@chakra-ui/react";
import { NO_SUBJECT } from "modules/utils/Constants";
import {
  getHighlightWithTopScore,
  getMessageThreadSeenSubjectFontWeight,
  getMessageThreadSubjectColor,
} from "modules/utils/Functions";
import { HappycoWorkOrderFragment, SearchHighlightFragment } from "gql/graphql";
import SearchHighlight from "../search/search-highlight";
import { HappycoMiniLogoIcon } from "modules/icons";
import colors from "app/colors";

interface IProps {
  //Not a full MessageThreadFragment, only the fields needed so that both a  MessageThreadFragment and a RelatedMessageThreadFragment can be passed in
  messageThread: {
    subject?: string | null;
    isSeen?: boolean;
    highlights?: SearchHighlightFragment[] | null;
    happycoWorkOrder?: HappycoWorkOrderFragment | null;
  };
  fontSize?: number;
  noOfLines?: number;
  lineHeight?: string;
  strikethrough?: boolean;
}

const MessageThreadPreviewSubject = ({
  messageThread,
  fontSize = 16,
  noOfLines = 1,
  lineHeight,
  strikethrough,
}: IProps) => {
  const subject = messageThread.subject || NO_SUBJECT;

  const highlightWithTopScore = useMemo(
    () => getHighlightWithTopScore(messageThread.highlights),
    [messageThread.highlights],
  );

  const leftIcon = useMemo(() => {
    if (messageThread.happycoWorkOrder) {
      return <HappycoMiniLogoIcon boxSize={4} fill={colors.gray50} />;
    }
  }, [messageThread.happycoWorkOrder]);

  return (
    <HStack spacing={1}>
      {leftIcon}
      <Text
        fontWeight={getMessageThreadSeenSubjectFontWeight(messageThread.isSeen)}
        fontSize={fontSize}
        color={getMessageThreadSubjectColor(messageThread)}
        fontFamily="Outfit"
        noOfLines={noOfLines}
        lineHeight={lineHeight}
        wordBreak="break-all" // prevents long strings from taking too much space
        textDecoration={strikethrough ? "line-through" : "none"}
      >
        {highlightWithTopScore ? (
          <SearchHighlight
            highlight={highlightWithTopScore}
            truncateString={false}
          />
        ) : (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>{subject}</>
        )}
      </Text>
    </HStack>
  );
};

export default memo(MessageThreadPreviewSubject);
